import React from 'react'
import {
    StyledFlyoutNavActions,
    StyledIconUser,
    StyledUserLink,
    StyledUserName,
} from './FlyoutNavActions.styled'
import { useSelector } from 'react-redux'
import { AppState } from 'common/store'

interface FlyoutNavActionProps {
    LoginAction: React.ReactType
    LogoutAction: React.ReactType
    SubscribeAction: React.ReactType
}
export const FlyoutNavActions: React.FC<FlyoutNavActionProps> = ({
    LoginAction,
    LogoutAction,
    SubscribeAction,
}) => {
    const { isLoggedIn, userName } = useSelector((state: AppState) => state.authentication)

    return (
        <StyledFlyoutNavActions>
            {!isLoggedIn ? (
                <React.Fragment>
                    <SubscribeAction />
                    <LoginAction />
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <StyledUserLink
                        to={'https://subscriber.thewest.com.au/myaccount'}
                        rel="noopener"
                        openExternalInNewWindow={true}
                    >
                        <StyledUserName>{userName}</StyledUserName> <StyledIconUser />
                    </StyledUserLink>
                    <LogoutAction />
                </React.Fragment>
            )}
        </StyledFlyoutNavActions>
    )
}
